/* ============================================================
   PDP module: curtain-hook quantity calculator
   Vanilla, scoped per instance, idempotent. Theme-editor aware.
   ============================================================ */
(function () {
  'use strict';

  function initInstance(root) {
    if (!root || root.dataset.chcReady === '1') return;
    root.dataset.chcReady = '1';

    var widthInput = root.querySelector('[data-chc-width]');
    var unitBtns   = root.querySelectorAll('[data-chc-unit]');
    var calcBtn    = root.querySelector('[data-chc-calc]');
    var media      = root.querySelector('[data-chc-media]');
    var result     = root.querySelector('[data-chc-result]');
    var valueEl    = root.querySelector('[data-chc-value]');
    if (!widthInput || !calcBtn || !result || !valueEl) return;

    var perMeter = parseFloat(root.dataset.perMeter);
    if (isNaN(perMeter) || perMeter <= 0) perMeter = 8;

    var unit = 'cm';

    function showResult(show) {
      if (media) media.hidden = show;
      result.hidden = !show;
    }

    function scrollToResult() {
      if (!window.matchMedia || !window.matchMedia('(max-width: 749px)').matches) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      result.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }

    function compute(scroll) {
      var raw = parseFloat(widthInput.value);
      if (!raw || isNaN(raw) || raw <= 0) {
        valueEl.textContent = '—';
        showResult(false);
        return;
      }
      var meters = unit === 'm' ? raw : raw / 100;
      var hooks = Math.ceil(meters * perMeter);
      valueEl.textContent = String(hooks);
      showResult(true);
      if (scroll) scrollToResult();
    }

    calcBtn.addEventListener('click', function () { compute(true); });

    widthInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        compute(true);
      }
    });

    Array.prototype.forEach.call(unitBtns, function (btn) {
      btn.addEventListener('click', function () {
        unit = btn.getAttribute('data-chc-unit') || 'cm';
        Array.prototype.forEach.call(unitBtns, function (b) {
          var active = (b === btn);
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (!result.hidden) compute();
      });
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-curtain-calc]');
    Array.prototype.forEach.call(nodes, initInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: the product section re-renders on edit.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
